import React from "react";
import PropTypes from "prop-types";
import styled, {keyframes} from 'styled-components';
import circularDots from 'assets/icons/circulardots.svg'


const ProgressBarContainer = styled.div`
  max-height: ${p => p.progress > 0 ? '20px' : '0'};
  height: 20px;
  background: #3BCE7F;
  position: absolute;
  width: 100%;
  overflow: hidden;
  z-index: 3;
  display: flex;
  align-items: center;
  flex: 1;
  transition: max-height 0.1s ease-out;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const LoadingIcon = styled.img`
  animation: ${rotate} 2s linear infinite;
  width: 10px;
  height: 10px;
  margin-left: 24px;
  position: absolute;
  left: 0;
  margin-right: 8px;
`;

const LoadingText = styled.div`
  color: #FFFFFF;
  overflow: hidden;
  flex-grow: 1;
  font-size: 9px;
  line-height: 11px;
  position: absolute;
  left: 40px;
  max-height: ${p => p.progress > 0 ? '20px' : '0'};
  transition: max-height 0.1s ease-out;
`;

const CompletionText = styled.div`
  color: #FFFFFF;
  right: 20px;
  overflow: hidden;
  position: absolute;
  font-size: 9px;
  line-height: 11px;
  margin-right: 20px;
  max-height: ${p => p.progress > 0 ? '20px' : '0'};
  transition: max-height 0.1s ease-out;
`;

const ProgressBarCompletion = styled.div`
  background: #2ABD6E;
  position: relative;
  height: 18px;
  border-radius: 0 9px 9px 0;
  max-height: ${p => p.percentage > 0 ? '18px' : '0'};
  width: ${p => p.percentage ? `${p.percentage}%` : '50%'};
  transition: ${p => p.percentage > 10 ? `width 2s ease-in, max-height 0.1s ease-out;`:''}
`;

const ProgressBar = ({ percentage, Language }) => {
    return (
        <ProgressBarContainer progress={percentage}>
            <ProgressBarCompletion percentage={percentage}/>
            <LoadingIcon src={circularDots}/>
            <LoadingText progress={percentage}>{Language.Uploading}</LoadingText>
            <CompletionText progress={percentage}>{Math.round(percentage)}%</CompletionText>
        </ProgressBarContainer>
    );
};

ProgressBar.defaultProps = {
    percentage: 0,
};

ProgressBar.propTypes = {
    percentage: PropTypes.number,
};

export default ProgressBar;
